import { useFeatureFlag } from '@webapp/hooks'
import { IS_PROD } from '@webapp/infrastructure/envs'

export const useContactSupportLink = () => {
  const FT_4880_ENABLE_INTERCOM = useFeatureFlag('FT_4880_ENABLE_INTERCOM')

  return {
    states: {
      isIntercomEnabled:
        FT_4880_ENABLE_INTERCOM && IS_PROD && !!window?.Intercom,
    },
    commands: {
      openNewIntercomMessage: () => {
        window.Intercom('showNewMessage')
      },
    },
  }
}
